import Vue from 'vue';
import Router from 'vue-router';
import firebase from 'firebase/app';
import 'firebase/auth';

const MainViews = () => import('@/views/MainView.vue');
const BookAdd = () => import('@/views/BookAddView.vue');
const Register = () => import('@/views/RegisterView.vue');
const Login = () => import('@/views/Login.vue');
const ImpressionsList = () => import('@/views/ImpressionsListView.vue');
const ShareView = () => import('@/views/ShareView.vue');

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login,
    },
    {
      path: '/impressions',
      component: MainViews,
      meta: {requiresAuth: true},
      children: [
        {
          path: '/',
          name: 'imp_list',
          component: ImpressionsList,
        },
        {
          path: 'book_add',
          name: 'book_add',
          component: BookAdd,
        },
        {
          path: 'register',
          name: 'register',
          component: Register,
        },
      ],
    },
    {
      meta: {requiresAnonymousAuth: true},
      path: '/share/page/:id',
      name: 'share',
      component: ShareView,
    },
    {
      path: '*',
      redirect: {name: 'login'},
    },
  ],
});


router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
  const requiresAnonymousAuth = to.matched.some((record) => record.meta.requiresAnonymusAuth);

  if (requiresAuth) {
    firebase.auth().onAuthStateChanged((user) => {
      if (user && !user.isAnonymous) {
        next();
      } else {
        next('/login');
      }
    });
  } else if (requiresAnonymousAuth) {
    firebase.auth().onAuthStateChanged((user) => {
      const id: string = to.params.id;
      if (user && user.isAnonymous && id.length !== 0) {
        next();
      } else {
        next('/login');
      }
    });
  } else {
    next();
  }
});

export default router;
